import * as tslib_1 from "tslib";
import { css } from 'styled-components';
import Color from 'color';
import { grey } from '../styles/colors';
import { getColorFromTheme, isEmptyOfColorType } from '../utils/colors';
/**
 * 按钮文本颜色
 */
var getTextColor = function (props) {
    if (props.disabled) {
        return props.theme.palette.action.disabled;
    }
    if (isEmptyOfColorType(props)) {
        return props.theme.palette.shades.light.text.primary;
    }
    return props.theme.palette.shades.dark.text.primary;
};
/**
 * 获取浮动按钮的背景色
 */
var getBgColor = function (props) {
    if (props.disabled) {
        return props.theme.palette.text.divider;
    }
    return getColorFromTheme(props, grey[300]);
};
/**
 * 获取悬浮情况下的按钮背景色
 */
var getHoverBgColor = function (props) {
    var bgColor = getBgColor(props);
    if (bgColor && bgColor !== 'inherit' && bgColor !== 'currentColor') {
        return Color(bgColor)
            .darken(0.12)
            .rgb()
            .string();
    }
    return bgColor;
};
var RaisedButtonStyle = css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  box-shadow: ", ";\n  color: ", ";\n  background-color: ", ";\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (props) { return !props.disabled && props.theme.shadows[2]; }, getTextColor, getBgColor, getHoverBgColor);
export default RaisedButtonStyle;
var templateObject_1;
//# sourceMappingURL=RaisedButtonStyle.js.map